import { getCourseList } from '@/actions/courses';
import CourseGrid from '@/components/landing/course/CourseGrid';
import SEO from '@/components/landing/seo';
import Footer from '@/components/layout/landing/Footer';
import NavbarNew from '@/components/layout/landing/NavbarNew';
import { useRouter } from 'next/router';
import { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const Courselist = () => {
  const dispatch = useDispatch();
  const router = useRouter();

  // const [loading, setLoading] = React.useState<boolean>(false);
  const [query, setQuery] = useState<object>({
    name: '' as any,
    test: '' as any,
    course_type: '' as any,
    rating: '' as any,
    sort: '' as any,
    page: 1,
    per_page: 12,
  });

  // useEffect(() => {
  //   const start = () => {
  //     setLoading(true);
  //   };
  //   const end = () => {
  //     setLoading(false);
  //   };
  //   Router.events.on('routeChangeStart', start);
  //   Router.events.on('routeChangeComplete', end);
  //   Router.events.on('routeChangeError', end);
  //   return () => {
  //     Router.events.off('routeChangeStart', start);
  //     Router.events.off('routeChangeComplete', end);
  //     Router.events.off('routeChangeError', end);
  //   };
  // }, []);

  useEffect(() => {
    let dataQuery = {
      name: router?.query?.name || '',
      test: router?.query?.test || '',
      course_type: router?.query?.course_type || '',
      rating: router?.query?.rating || '',
      sort: router?.query?.sort || '',
    };
    setQuery({
      ...query,
      ...dataQuery,
    });
    dispatch(
      getCourseList({
        ...query,
        ...dataQuery,
      })
    );
  }, [
    JSON.stringify([
      router?.query?.test,
      router?.query?.price,
      router?.query?.name,
      router?.query?.page,
      router?.query?.per_page,
      router?.query?.sort,
      router?.query?.course_type,
    ]),
  ]);

  return (
    <>
      <SEO
        meta_title={'Course List | Learnsic'}
        meta_description={'Learnsic courses'}
        meta_keywords={
          'Learnsic courses, Best Online courses, Online courses in Nepal'
        }
        photo={''}
        canonical="course"
      />
      <NavbarNew />
      <CourseGrid />
      <Footer />
    </>
  );
};

export default memo(Courselist);
